import { Dispatch, SetStateAction } from "react";
import EstablishmentNodeForm from "./EstablishmentNodeForm";

const EstablishmentNodeEdit = ({
  nextButtonFunction,
  establishmentID,
  interfaceData,
  updateInterfaceData,
  setIsEstablishmentNodeInit
}: EstablishmentNodeEditProps) => {

  const initialValues: IEstablishmentNodeForm = {
    nodeID: interfaceData.nodeID
  }

  const handleSubmit = async (values: IEstablishmentNodeForm) => { 
    updateInterfaceData(values);
    setIsEstablishmentNodeInit(true);
    nextButtonFunction();
  };
  
  return (
    <>
      
        <EstablishmentNodeForm 
          type={"edit"} 
          initialValues={initialValues} 
          onSubmit={handleSubmit}    
        />
       
    </>
    
  )
}

export default EstablishmentNodeEdit;

type EstablishmentNodeEditProps = {
  interfaceData: IEstablishmentInterfaceForm
  nextButtonFunction: () => void;
  establishmentID?: number;
  setIsEstablishmentNodeInit: Dispatch<SetStateAction<boolean>>;
  updateInterfaceData: (data: Partial<IEstablishmentInterfaceForm>) => void;
}